module.exports = __webpack_public_path__ + "img/citrom-icon-white.2a30ed52.svg";